import { connsPublic } from '@cfg/axiosConfig.tsx';
import {
  filterActiveFooterShippingMethods,
  mergeFooterPaymentMethods,
  type PublicPaymentMethod,
  type PublicShippingMethod,
} from './footerDataUtils.ts';

export const fetchFooterPublicData = async (): Promise<{
  paymentMethods: PublicPaymentMethod[];
  shippingMethods: PublicShippingMethod[];
}> => {
  const [deliveryPayments, pickupPayments, shipping] = await Promise.allSettled([
    connsPublic<PublicPaymentMethod[]>('eshop:payment:methods').get({ takeaway: false }),
    connsPublic<PublicPaymentMethod[]>('eshop:payment:methods').get({ takeaway: true }),
    connsPublic<PublicShippingMethod[]>('eshop:shipping:active_list').get(),
  ]);

  const paymentGroups = [deliveryPayments, pickupPayments].flatMap((result) =>
    result.status === 'fulfilled' ? [result.value.data] : []);

  return {
    paymentMethods: mergeFooterPaymentMethods(paymentGroups),
    shippingMethods: shipping.status === 'fulfilled'
      ? filterActiveFooterShippingMethods(shipping.value.data)
      : [],
  };
};
